export default __webpack_public_path__ + "static/media/CertificateIEC.f3240a1f.png";